import React, { useEffect } from 'react';
import ECLandingSec1 from './ec-landing-sec1';
import ECSignupForm from './ec-signup-form';
import ECLandingSections from './ec-landing-sections';

function ECSignupPage() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="bg-[#F4F0FA]">
                <div className="flex justify-center gap-28 py-9 xl:py-28 max-xs:flex-col mx-16 xl:m-auto max-w-[93rem] max-xs:mx-0">
                    <ECLandingSec1 />
                    <ECSignupForm />
                </div>
            </div>
            <ECLandingSections />
        </>
    )
}

export default ECSignupPage
